import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=52aaeb3d&scoped=true"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"
import style1 from "./Item.vue?vue&type=style&index=1&id=52aaeb3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52aaeb3d",
  null
  
)

export default component.exports